export const byPass = {
  'no-check': null,
  'simple-check': 'image/*',
  'ratio-check': 'image/*',
  'audio-check': 'audio/*',
  'video-check': 'video/*',
}
